<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="row d-flex justify-content-between">
            <h4 slot="header" class="col-lg-6 card-title">
              Marcas
              <TotalRegisters :total="brandsTableData.total" totalText="marcas cadastradas" />
              <div class="d-flex">
                <div class="search-control" style="max-width: 240px">
                  <input class="form-control" type="text" placeholder="Buscar" v-model="search" @keyup="doSearch(search)" />
                </div>

                <div class="ml-1 d-flex">
                  <div v-click-outside="closeDropdown" class="dropdown dropdown-black" :class="{ show: filterBranch }">
                    <button @click="filterBranch = !filterBranch" class="btn btn-secondary form-control dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <label id="lblDropdown" class="form-check-label" style="font-weight: 500" v-if="!convertedSelectedBranch">Filtrar por ramos</label>
                      <span v-for="b in selectedBranch" :key="b.id" class="d-inline-flex badge badge-primary mr-2">
                        {{ b.name }}
                        <span class="bgc badge__close" @click="selectedBranch = selectedBranch.filter((s) => s.id !== b.id)">
                          <i class="vs-icon-close vs-icon-hover-less"></i>
                        </span>
                      </span>
                    </button>

                    <div class="dropdown-menu dropdown-black" aria-labelledby="dropdownMenuButton">
                      <div class="dropdown-header">
                        <input class="form-control" type="text" placeholder="Buscar" v-model="inputBranch" />
                      </div>

                      <div class="dropdown-body scroll-custom" style="max-height: 320px; overflow: auto">
                        <div class="px-3" v-if="filteredBranches.length > 0">
                          <div class="form-check" v-for="b in filteredBranches" :key="b.id">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" :value="{ name: b.name, id: b.id }" v-model="selectedBranch" />
                              {{ b.name }}
                              <span class="form-check-sign">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <p class="dropdown-item" v-else>Nenhum resultado encontrado</p>
                      </div>
                    </div>
                  </div>
                </div>

                <button class="search__btn" @click="doSearch(search)">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </h4>

            <div class="col-lg-6 d-flex align-items-end justify-content-end mb-3">
              <button class="btn btn-info btn-sm" @click="openCustomQuestionModal()">Adicionar pergunta personalizada</button>
              <button class="btn btn-info btn-sm ml-2" id="openModalBrand" @click="visibilityStates.createVisibility = true">Adicionar marca</button>
            </div>
          </div>

          <Table :tableData="brandsTableData" :data="brands" :columns="['id', 'name', 'branchName', 'actions']" :actions="['edit']" @pagechanged="onPageChange" @openEditModal="openEditModal"> </Table>
          <ListLoader v-if="brandsTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!brandsTableData.loading && brandsTableData.error"></Error>
          <Empty v-if="!brandsTableData.loading && !brandsTableData.error && brands.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Modal Add -->
    <Modal v-model="visibilityStates.createVisibility" successMessage="Marca criada com sucesso!" action="Adicionar" title="Adicionar marca" :buttonDisabled="buttonDisabled" :scroll="true" @closeModal="clearAddModal()" @confirmAction="create(newBrand, 'add')">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" id="input1toTest" placeholder="Ex: Magazine Luiza" v-model="newBrand.name" @input="errorBrand = false" />
          <span v-if="errorBrand" class="validate__error"><i class="fas fa-exclamation-circle"></i>&nbsp;&nbsp;Marca já cadastrada</span>
        </div>
        <div class="form-group">
          <label>Ramo</label>
          <treeselect @input="getItemsByBranch(newBrand.branchId)" v-model="newBrand.branchId" :multiple="false" :options="branches" :flat="false" :normalizer="normalizer" placeholder="Selecione o ramo da marca" />
        </div>
        <div class="form-group">
          <label>Produtos e Serviços</label>
          <treeselect v-model="newBrand.items" placeholder="Selecione os produtos e serviços do ramo" :limit="6" :limitText="(count) => `e ${count} outros itens`" :multiple="true" value-format="object" :options="hasBranch ? items : []" :flat="true" :normalizer="normalizer" />
        </div>
        <div class="form-group">
          <label>Tipo de marca (Deixe em branco para usar a pergunta padrão)</label>
          <treeselect v-model="newBrand.brandsTypeId" placeholder="Selecione o tipo de marca" value-format="object" :multiple="false" :flat="false" :options="brandTypes" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Logo <span style="font-size: 12px; color: rgba(255, 255, 255, 0.8)">(Tamanho recomendado: 600x400)</span></label>
          <div v-if="brand.image">
            <div>
              <img class="mb-3" style="max-width: 100px" :src="brand.imageDetails.location" />
              <input type="text" class="form-control" :placeholder="brand.imageDetails.location" />
            </div>
          </div>
          <div class="d-flex align-items-center">
            <button v-if="!brand.image" type="button" class="d-block btn btn-primary" style="max-height: 45px" id="uploadImageTest" @click="$refs.file.click($event)">Upload da Imagem</button>
            <img class="float-right w-25 ml-4" id="preview" v-if="url" :src="url" />
          </div>
          <input id="onFileChangeTest" class="cursor-pointer" type="file" ref="file" @change="onFileChange" />
          <div class="mt-3" id="arquivo">Arquivo Selecionado: {{ newFile ? newFile.name : '' }}</div>
        </div>
      </template>
    </Modal>

    <!-- Modal Custom Question -->
    <Modal v-model="visibilityStates.customQuestionVisibility" successMessage="Pergunta criada com sucesso!" action="Adicionar" title="Adicionar Pergunta Personalizada" :scroll="true" @closeModal="clearFields" @confirmAction="addCustomQuestion(newCustomQuestion)">
      <template v-slot:body>
        <div class="form-group">
          <label>Selecione a marca</label>
          <treeselect @input="getItemById(newCustomQuestion.brandsId)" v-model="newCustomQuestion.brandsId" :multiple="false" :options="brandList" :flat="false" :normalizer="normalizer" :beforeClearAll="clearBrandsItems" :clear="true" />
        </div>
        <div v-if="showProductsAndServices" class="form-group">
          <label>Produtos e Serviços</label>
          <treeselect
            v-model="newCustomQuestion.itemObj"
            placeholder="Selecione os produtos e serviços do ramo"
            :limit="6"
            :limitText="(count) => `e ${count} outros itens`"
            :multiple="false"
            value-format="object"
            :options="brandsItems.data"
            :flat="true"
            :normalizer="normalizer"
          />
        </div>
        <div class="mt-2">
          <label>Pergunta</label>
          <input class="form-control" type="text" name="question" v-model="newCustomQuestion.question" />
        </div>
        <div class="form-group mt-2">
          <label>Tipo de Resposta</label>
          <select v-model="typeField" placeholder="select..." class="form-control">
            <option value="smallText">Resposta curta</option>
            <option value="radio">Múltipla escolha</option>
          </select>
        </div>
        <div v-if="typeField === 'smallText'" class="mt-2"><input class="form-control" placeholder="Dica de resposta. Ex.: Av. Bandeirantes" type="text" name="smallText" v-model="newCustomQuestion.tip" maxlength="200" /></div>
        <div class="mt-2" style="max-height: 20vh; overflow: auto" v-if="typeField === 'radio'">
          <label class="mb-0">Opções</label>
          <div v-for="opt in options" :key="opt.id" class="form-group d-flex" style="justify-content: space-between">
            <div class="d-flex align-items-center">
              <input type="radio" :checked="false" disabled />
              <input type="text" class="form-control ml-2" v-model="opt.label" />
            </div>
            <div>
              <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group mt-2" v-if="typeField === 'radio'">
          <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
        </div>
      </template>
    </Modal>

    <!-- Modal Edit -->
    <Modal v-model="visibilityStates.editVisibility" successMessage="Marca atualizada com sucesso!" action="Atualizar" :name="brand.name" title="Editar Marca" :scroll="true" @closeModal="clearEditModal()" @confirmAction="update(brand, 'edit')">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="brand.id" />
          <input type="text" class="form-control" v-model="brand.name" />
        </div>
        <div class="form-group">
          <label>Ramo</label>
          <treeselect @input="getItemsByBranch(brand.branch.id)" v-model="brand.branch" :multiple="false" value-format="object" :options="branches" :flat="false" :normalizer="normalizer" />
        </div>
        <div class="form-group">
          <label>Produtos e Serviços</label>
          <treeselect v-model="brand.items" placeholder="Selecione os produtos e serviços do ramo" :limit="6" :limitText="(count) => `e ${count} outros itens`" :multiple="true" value-format="object" :options="items" :flat="true" :normalizer="normalizer" />
        </div>
        <div class="form-group">
          <label>Tipo de marca (Deixe em branco para usar a pergunta padrão)</label>
          <treeselect v-model="brand.brandsType" placeholder="Selecione o tipo de marca" value-format="object" :multiple="false" :flat="false" :options="brandTypes" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Logo <span style="font-size: 12px; color: rgba(255, 255, 255, 0.8)">(Tamanho recomendado: 600x400)</span></label>
          <div v-if="brand.image_name !== ''">
            <img ref="file" style="max-width: 100px" :src="brand.image_url" />
          </div>
          <button type="button" class="mt-3 d-block btn btn-primary float-left" @click="$refs.file.click()">Upload da Imagem</button>
          <input style="visibility: hidden" type="file" id="file" ref="file" @change="onFileChange($event)" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Table from '@/components/Common/Table';
import { RepositoryFactory } from '../RepositoryFactory';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import api from '@/api.js';
import Search from '@/components/Common/Search';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Modal from '@/components/Modal/Modal';
import Pagination from '@/components/Pagination/Pagination';
import NotificationSuccess from './Notifications/NotificationSuccess';

export default {
  components: {
    Pagination,
    Treeselect,
    Modal,
    TotalRegisters,
    Search,
    Table,
  },
  data() {
    return {
      regions: [],
      newBrand: {
        branchId: null,
      },
      selectedBranch: [],
      filterBranch: false,
      inputBranch: '',

      search: '',
      temporaryImage: null,

      // Modal States
      visibilityStates: {
        createVisibility: false,
        editVisibility: false,
        customQuestionVisibility: false,
      },
      errorBrand: false,
      typeField: '',
      options: [],
      newCustomQuestion: {
        brandsId: null,
        question: '',
        tip: null,
        options: null,
        itemObj: null,
        itemId: null,
      },
      brandList: [],
      brandsItems: [],
      showProductsAndServices: false,
      hasError: false,
      file: '',
      newFile: '',
      url: null,
    };
  },
  computed: {
    filteredBranches() {
      return this.branches.filter((s) => s.name.toLowerCase().includes(this.inputBranch.toLowerCase()));
    },
    brand() {
      return this.$store.getters['brands/getBrand'];
    },
    branches() {
      return this.$store.getters['branches/getBranches'];
    },
    brands() {
      return this.$store.getters['brands/getBrands'];
    },
    brandsTableData() {
      return this.$store.getters['brands/getBrandsTableData'];
    },
    convertedSelectedBranch() {
      return this.selectedBranch.map((s) => s.id).join(',');
    },
    items() {
      return this.$store.getters['items/getItems'];
    },
    hasBranch() {
      return this.newBrand.branchId !== null;
    },
    brandTypes() {
      return this.$store.getters['brandTypes/getBrandsTypes'];
    },
    buttonDisabled() {
      return !this.file || !this.newBrand.hasOwnProperty('name') || this.newBrand.name === '';
    },
  },
  methods: {
    clearFileAndUrl() {
      this.url = null;
      this.newFile = '';
    },
    clearEditModal() {
      this.visibilityStates.editVisibility = false;
      this.brand.image_url = '';
      this.clearFileAndUrl();
    },
    clearAddModal() {
      this.visibilityStates.createVisibility = false;
      this.newBrand = {};
      this.clearFileAndUrl();
    },

    closeDropdown: function (event) {
      this.filterBranch = false;
    },
    doSearch: async function (search) {
      let extraParams = null;
      let payload = {};

      if (this.convertedSelectedBranch) {
        payload.extraParams = { name: 'branch_id', id: this.convertedSelectedBranch };
      }

      payload.search = search;

      if (search === '' && !this.convertedSelectedBranch) {
        this.$store.dispatch('brands/resetPagination');
      } else {
        this.$store.dispatch('brands/searchBrand', payload);
      }
    },
    onFileChange(e) {
      const localFile = e.target.files[0];
      this.url = URL.createObjectURL(localFile);
      this.brand.image_url = this.url;
      this.file = this.$refs.file.files[0];
      const imageName = this.file.name.replace(/\s+/g, '_');
      this.newFile = new File([this.file], imageName, { type: this.file.type });
    },
    submitFile: async function (brandId) {
      let formData = new FormData();
      formData.append('image', this.newFile);
      this.temporaryImage = formData;
      await api.patch(`brands/images/${brandId}`, this.temporaryImage, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      this.temporaryImage = null;
    },
    getRegions: async function () {
      const { data } = await api.get('regions/states');
      this.regions = data;
    },
    onPageChange(page) {
      this.$store.dispatch('brands/setPage', page);
    },
    normalizerRegions(node) {
      if (!node.city) {
        return {
          id: node.id,
          label: node.state,
          children: node.cities,
        };
      } else {
        return {
          id: node.id,
          label: node.city,
        };
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    openEditModal: async function (id) {
      const brand = await this.$store.dispatch('brands/getBrandById', id);
      await this.getItemsByBranch(brand.branchId);
      this.visibilityStates.editVisibility = true;
    },
    openCustomQuestionModal: async function () {
      const response = await api.get('brands');
      this.brandList = response.data;
      this.visibilityStates.customQuestionVisibility = true;
    },

    addOption() {
      let optionsLength = this.options.length;
      optionsLength++;
      this.options.push({ id: optionsLength, label: `Opção ${optionsLength}` });
    },
    removeOption(id) {
      this.options = this.options.filter((s) => s.id !== id);
    },
    update: async function (brand) {
      const payload = {
        id: brand.id,
        params: {
          name: brand.name,
          branchId: brand.branch.id,
          items: brand.items,
          brandsTypeId: brand.brandsType ? brand.brandsType.id : null,
        },
      };
      if (this.file !== '') {
        this.submitFile(this.brand.id);
      }
      await this.$store.dispatch('brands/update', payload);
      this.visibilityStates.editVisibility = false;
      this.clearFileAndUrl();
      this.doSearch(this.search);
    },
    create: async function (brand) {
      const payload = brand;
      payload['brandsTypeId'] = brand.brandsType ? brand.brandsType.id : null;
      const brandId = await this.$store.dispatch('brands/createBrand', payload);
      this.submitFile(brandId);
      this.visibilityStates.createVisibility = false;
      this.newBrand = {};
      this.clearFileAndUrl();
    },
    getItemsByBranch: async function (id) {
      await this.$store.dispatch('items/getItemsByBranchId', id);
    },
    getItemById: async function (id) {
      if (id != undefined) {
        this.brandsItems = await api.get('items/brands/' + id);
      } else {
        this.brandsItems = [];
      }
      if (this.brandsItems.hasOwnProperty('data') && this.brandsItems.data.length != 0) {
        this.showProductsAndServices = true;
      } else {
        this.showProductsAndServices = false;
      }
    },
    clear() {
      Object.assign(this.$data.brand, this.$options.data().brand);
      Object.assign(this.$data.visibilityStates, this.$options.data().visibilityStates);
    },
    clearBrandsItems() {
      this.brandsItems = [];
      this.newCustomQuestion.brandsId = null;
      this.newCustomQuestion.itemId = null;
      this.newCustomQuestion.itemObj = null;
    },
    clearFields() {
      this.newCustomQuestion = {};
      this.typeField = '';
      this.showProductsAndServices = false;
      this.visibilityStates.customQuestionVisibility = false;
    },
    isSmallText() {
      return this.typeField === 'smallText';
    },
    hasSelectedProductsAndServices() {
      return this.newCustomQuestion.itemObj != null;
    },
    showSuccess(message) {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: message,
      });
    },
    showError(message) {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'danger',
        timeout: 3000,
        message: message,
      });
    },
    checkSelectedBrand(brand) {
      if (brand === null || brand === undefined) {
        this.hasError = true;
        this.showError('Erro: Marca não preenchida');
      }
    },
    checkSelectedQuestion(question) {
      if (question === '') {
        this.hasError = true;
        this.showError('Erro: Pergunta não preenchida');
      }
    },
    checkSelectedTypeField(typeField) {
      if (typeField === '') {
        this.hasError = true;
        this.showError('Erro: Tipo de resposta não preenchido');
      }
    },
    checkOptionOnTypeFieldRadio(options, typeField) {
      if (options != null && options.length === 0 && typeField === 'radio') {
        this.hasError = true;
        this.showError('Erro: Opções de resposta não inseridas');
      }
    },
    addCustomQuestion: async function () {
      if (this.isSmallText()) {
        this.newCustomQuestion.options = null;
      } else {
        this.newCustomQuestion.tip = null;
        this.newCustomQuestion.options = this.options;
        this.newCustomQuestion.options.map(function (item) {
          delete item.id;
          return item;
        });
      }
      if (this.hasSelectedProductsAndServices()) {
        this.newCustomQuestion.itemId = this.newCustomQuestion.itemObj.id;
      }
      delete this.newCustomQuestion.itemObj;
      try {
        this.hasError = false;
        this.checkSelectedBrand(this.newCustomQuestion.brandsId);
        this.checkSelectedQuestion(this.newCustomQuestion.question);
        this.checkSelectedTypeField(this.typeField);
        this.checkOptionOnTypeFieldRadio(this.newCustomQuestion.options, this.typeField);
        if (!this.hasError) {
          await api.post('/questions/custom', this.newCustomQuestion);
          this.clearFields();
          this.showSuccess('Questão adicionada com sucesso!');
        }
      } catch (error) {
        this.showError('Erro: Não foi possível salvar a pergunta');
      }
    },
  },

  mounted() {
    this.$store.dispatch('branches/getBranchesNoLimit');
    this.$store.dispatch('brandTypes/getBrandsTypesNoLimit');
    this.$store.dispatch('brands/resetPagination');
    this.$store.dispatch('brands/getBrandsNoLimit');
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  overflow: auto;
  height: 80vh;
}
</style>
<style>
.badge {
  position: relative;
}
.bgc.badge__close {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 15px;
  height: 15px;
  background: #1a1e34;
  /* border: 1px solid #344675; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.75rem;
  cursor: pointer;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.vs-icon-close {
  width: 30px;
  height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  transform: scale(0.5);
}
.vs-icon-close:after,
.vs-icon-close:before {
  background: #fff;
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.vs-icon-close:before {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.vs-icon-close:after {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.bgc.badge__close:hover .vs-icon-close:after,
.bgc.badge__close:hover .vs-icon-close:before {
  width: 12px;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.bgc.badge__close:hover {
  background: #ff4757;
}
.search-control {
  display: flex;
}
.search__btn {
  width: 50px;
  height: 38px;
  margin-left: 4px;
  font-size: 0.875rem;
  border-radius: 0.2857rem;
  padding: 5px 15px;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #1d8cf8;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
  border: none;
  cursor: pointer;
}
.vue-treeselect__menu-container {
  color: #039be5 !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.validate__error {
  color: red;
  font-size: 12px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background-color: #11171a;
  border-radius: 10px;
}
</style>
